import React from 'react';

// import styles
import kepInternalStyles from './../../styles/kepinternal.module.scss';

// import interfaces
import { IEventDataProps } from './../../props/data';
import { IListPanelClosed } from './../../props/general';

// import components
import Form from './../../components/forms/index';
import { IFormFieldProps } from './../../components/forms/formProps';

// import services
import EventService from './../../services/event';
import FormMetadataService from './../../components/forms/services/metadata';
import FormValidationService from './../../components/forms/services/validation';
import { MessageBarType, Stack, Spinner, SpinnerSize, PrimaryButton, DefaultButton, Panel } from '@fluentui/react';

// import fabric ui


// local interfaces

interface IEVentPropsPanelProps {
    isOpen: boolean;
    data?: IEventDataProps;
    onPanelClosed(props?: IListPanelClosed): void;
}

interface IEVentPropsPanelState {
    isOpen: boolean;
    saving: boolean;
    data?: IEventDataProps;
    isUpdate: boolean;
    formFields: IFormFieldProps[];
}

export default class EventPropsPanel extends React.Component<IEVentPropsPanelProps, IEVentPropsPanelState> {
    private eventService: EventService = new EventService();
    private defaultFormFields: IFormFieldProps[] = [
        {
            promoted: true,
            key: "id",
            title: "ID",
            type: "textfield",
            isRequired: false,
            isDisabled: true,
            isHidden: true
        },
        {
            promoted: true,
            key: "name",
            title: "Nama acara",
            type: "textfield",
            isRequired: true,
            isDisabled: false
        },
        {
            promoted: true,
            key: "type",
            title: "Tipe acara",
            type: "dropdown",
            choicesConfiguration: {
                choices: [
                    { key: "Libur", text: "Libur" },
                    { key: "Acara Bersama", text: "Acara Bersama" }
                ]
            },
            isRequired: true,
            isDisabled: false
        },
        {
            promoted: true,
            key: "startDate",
            title: "Tanggal mulai",
            type: "datepicker",
            isRequired: true,
            isDisabled: false
        },
        {
            promoted: true,
            key: "endDate",
            title: "Tanggal berakhir",
            type: "datepicker",
            isRequired: true,
            isDisabled: false
        }
    ];

    constructor(props: IEVentPropsPanelProps) {
        super(props);

        this.state = {
            isOpen: false,
            saving: false,
            isUpdate: props.data ? true : false,
            data: props.data,
            formFields: JSON.parse(JSON.stringify(this.defaultFormFields))
        }
    }

    public componentWillReceiveProps(props: IEVentPropsPanelProps) {
        this.setState({
            formFields: JSON.parse(JSON.stringify(this.defaultFormFields)),
            isOpen: props.isOpen,
            isUpdate: props.data ? true : false,
            data: props.data
        });
    }

    private _onPanelClosed = (props?: IListPanelClosed) => {
        this.props.onPanelClosed(props);
    }

    private _onCreate = async (): Promise<void> => {
        let fieldsValidation = FormValidationService.fields(this.state.formFields);
        if (!fieldsValidation.isError) {
            this.setState({
                saving: true,
                formFields: this.state.formFields.map((field) => {
                    field.isDisabled = true;
                    return field;
                })
            });

            try {
                let metadata = FormMetadataService.generate(this.state.formFields);
                let newData = await this.eventService.create(metadata);
                this.setState({ saving: false });
                this._onPanelClosed({
                    refreshData: true,
                    messageBar: {
                        text: `Acara ${newData.name} berhasil ditambahkan`,
                        type: MessageBarType.success
                    }
                });
            } catch (error) {

            }
        } else {
            this.setState({
                saving: false,
                formFields: fieldsValidation.fields.map((field) => {
                    field.isDisabled = false;
                    return field;
                })
            });
        }
    }

    private _onUpdate = async (): Promise<void> => {
        let fieldsValidation = FormValidationService.fields(this.state.formFields);
        if (!fieldsValidation.isError) {
            this.setState({ saving: true }); this.setState({
                saving: true,
                formFields: this.state.formFields.map((field) => {
                    field.isDisabled = true;
                    return field;
                })
            });

            try {
                let metadata = FormMetadataService.generate(this.state.formFields);
                let updatedData = await this.eventService.update(metadata.id, metadata);
                this.setState({ saving: false });
                this._onPanelClosed({
                    refreshData: true,
                    messageBar: {
                        text: `Acara ${updatedData.name} berhasil diubah`,
                        type: MessageBarType.success
                    }
                });
            } catch (error) {

            }
        }
    }

    private _onFormFieldsChanged = (fields: IFormFieldProps[]) => {
        this.setState({ formFields: fields, data: undefined });
    }

    private renderPanelFooter = (): JSX.Element => {
        return (
            <Stack horizontalAlign="baseline">
                {
                    this.state.saving ? (
                        <Spinner label={this.state.isUpdate ? "Mengubah data acara ... " : "Menambahkan acara baru ... "} labelPosition="right" size={SpinnerSize.medium} />
                    ) : null
                }
                {
                    !this.state.saving ? (
                        <Stack horizontal tokens={{ childrenGap: 10 }}>
                            <Stack.Item>
                                {this.state.isUpdate ? <PrimaryButton label={"Ubah"} onClick={this._onUpdate}>Ubah</PrimaryButton> : null}
                                {!this.state.isUpdate ? <PrimaryButton label={"Tambahkan"} onClick={this._onCreate}>Tambahkan</PrimaryButton> : null}
                            </Stack.Item>
                            <Stack.Item>
                                <DefaultButton label={"Tambahkan"} onClick={() => this._onPanelClosed()}>Batal</DefaultButton>
                            </Stack.Item>
                        </Stack>
                    ) : null
                }
            </Stack>
        );
    }

    public render() {
        return (
            <Panel
                headerText={this.props.data ? "Ubah Data Acara" : "Buat Acara Baru"}
                isOpen={this.state.isOpen}
                onDismiss={() => this._onPanelClosed()}
                closeButtonAriaLabel="Tutup"
                onRenderFooterContent={this.renderPanelFooter}
                isFooterAtBottom={true}>
                <Stack className={kepInternalStyles.form}>
                    <Form fields={this.state.formFields} onValueChanged={this._onFormFieldsChanged} defaultValue={this.state.data} />
                </Stack>
            </Panel>
        );
    }
}
